import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.css'
import App from './App'
import { Amplify } from 'aws-amplify'
import config from './config'
import { BrowserRouter as Router } from 'react-router-dom'
import './assets/css/material-dashboard-react.css?v=1.2.0'
import { StyledEngineProvider } from '@mui/material/styles'
import store from './store/index'

// Amplify v6 configuration
const setupConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      loginWith: {
        email: true,
      },
    },
  },
  Storage: {
    S3: {
      bucket: config.s3.BUCKET,
      region: config.s3.REGION,
    },
  },
  API: {
    REST: {
      root: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
    },
  },
  Analytics: {
    Pinpoint: {
      appId: config.analytics.appId,
      region: config.analytics.region,
    },
    disabled: true,
  },
}

console.log(setupConfig)

Amplify.configure(setupConfig)

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container)

root.render(
  <Router>
    <StyledEngineProvider injectFirst>
      <Provider store={store}>
        <App />
      </Provider>
    </StyledEngineProvider>
  </Router>
)
//registerServiceWorker();
